import { checkoutWidgetsSchema } from "@redotech/redo-conversion-core-common/checkouts/checkout-widgets-builder";
import * as zExt from "@redotech/rpc/ext";
import * as z from "zod";

const updateCheckoutWidgetInputSchema_ = z.object({
  widgetId: zExt.objectId(),
  widgetData: checkoutWidgetsSchema,
});

export const updateCheckoutWidget = {
  name: "updateCheckoutWidget" as const,
  input: updateCheckoutWidgetInputSchema_,
  output: z.object({}),
};
